import { render } from "./PasswordSection.vue?vue&type=template&id=6ab0d38e"
import script from "./PasswordSection.vue?vue&type=script&lang=js"
export * from "./PasswordSection.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__